import React, { useState } from "react";
import { Typography } from "antd";
import { ModalBase } from "../../../../../Components/Modais/ModalBase/ModalBase";
import ButtonActions from "../../../../../Components/Buttons/ButtonActions/ButtonActions";
import Spinner from "../../../../../Components/Spinner";
import { useValidateCrfa } from "../../hooks/useValidateCrfa";

const { Text } = Typography;

const ModalApprove = ({ open, onClose, selectedDocument, getPendingCrfa }) => {
  const { approvedCrfa } = useValidateCrfa();
  const [isLoading, setIsLoading] = useState(false);

  // Aprova o documento e atualiza a lista de pendentes
  const handleApproved = async () => {
    setIsLoading(true);

    try {
      await approvedCrfa(selectedDocument.user_sub, "approved_documentation");

      // Busca novamente os documentos pendentes
      await getPendingCrfa();

      // Fecha o modal após a atualização
      onClose();
    } catch (error) {
      console.log("Erro ao aprovar:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalBase
      animated={false}
      open={open}
      onCancel={isLoading ? undefined : onClose}
      title="Aprovar documento?"
      width={600}
      footerAlign="center"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <ButtonActions variant="outline" onClick={onClose} text="FECHAR" />

          <ButtonActions
            variant="primary"
            onClick={handleApproved}
            text="APROVAR CARTEIRINHA"
            disabled={isLoading}
          />
        </div>
      }
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            height: 300,
            padding: 5,
          }}
        >
          <Text>
            Ao aprovar este documento, a validação do CRFa do profissional será
            concluída.
          </Text>
        </div>
      )}
    </ModalBase>
  );
};

export default ModalApprove;
